import React from "react";

const MenuDropdownContext = React.createContext({
    isOpen: false,
    isInsideDropdown: false,
});

export default MenuDropdownContext;
